import * as React from 'react';
import {Link} from "react-router";
import Input from '../Input-new/Input';
import svgPlus from "../../svgs/TrainingPlus.svg";
import Icon from "../Icon";
import Trash from "../../svgs/Trash.svg";


export default function SubChapterCard({id, title, img, index, link, newWindow, handleParentChange, handleParentBlur, isEdit, error, validateSelectedFile, deleteCard, removePhoto, newChapter, isNewChapter, addNewChapter, canDelete}) {
    const fileInputRef = React.createRef();
    
    const chooseFile = (e) => {
        validateSelectedFile(e, id)
    }
    return (
        !isEdit ?
        <Link to={link} target={newWindow ? '_blank' : ''} className="SubChapterCard">
            <div className="card_body">
                <img src={img} className="card_image" alt=''/>
            </div>
            <div className="card_title">
                {
                    index &&
                    <div className="index">#{index} - </div>
                }
                {
                    title && title.includes('<br/>') ?
                        title.split('<br/>').map((row, index) => <React.Fragment key={index}>{row}<br/></React.Fragment>)
                        :
                        title
                }
            </div>
        </Link>
        :
        !isNewChapter ?
            <div className="SubChapterCard">               
                <div className="card_body">
                    {
                        canDelete &&
                        <div className="deleteIcon">
                            <Icon svg={Trash} onClick={()=>deleteCard(id)}/>
                        </div>
                    }
                    <div className='overlay'/>
                    <input className='hidden' type="file" 
                    ref={fileInputRef} 
                    accept={"image/png, image/jpeg, image/jpg, .svg"} 
                    onChange={chooseFile}
                    />
                    <div className="button-container">
                        <input className={`button-new ${!img ? 'positive':'negative'}`}
                                type="button"
                                value={`${!img ?'Choose' : 'Remove'} Photo`}
                                onClick={!img ? () => fileInputRef.current.click() : () => removePhoto(id)} 
                                />
                    </div>
                    <div className="error-container">
                        {
                            error &&
                            <span className='error'>{error}</span>
                        }
                    </div>
                    {
                        img &&
                        <img src={img} className="card_image" alt=''/>
                    }
                </div>
                <div className="card_title">
                    <div className="index">
                        #
                        <Input theme='white' 
                            name={id+'_index'}
                            value={index}
                            handleParentChange={handleParentChange}
                            handleParentBlur={handleParentBlur}/> 
                        -
                    </div>
                    <Input theme='white' 
                            className='title-input'
                            name={id+'_title'}
                            value={title}
                            handleParentChange={handleParentChange}
                            handleParentBlur={handleParentBlur}/> 
                </div>                    
            </div>
        :
        <React.Fragment> 
            {newChapter.visible &&
            <div className="SubChapterCard">
                <div className="card_body">
                    <div className='overlay'/>
                    <input className='hidden' type="file" ref={fileInputRef} accept={"image/png, image/jpeg, image/jpg, .svg"} onChange={validateSelectedFile}/>
                    <div className='button-container'>
                        <input className={`button-new ${!newChapter.img ? 'positive':'negative'}`}
                                type="button"
                                value={`${!newChapter.img ?'Choose' : 'Remove'} Photo`}
                                onClick={!newChapter.img ? () => fileInputRef.current.click() : () => removePhoto()} />
                        {
                            error &&
                            <span className='error'>{error}</span>
                        }
                    </div>
                    {
                        newChapter.img &&
                        <img src={newChapter.img} className="card_image" alt=''/>
                    }
                </div>
                <div className="card_title">
                    <div className="index">
                        #
                        <Input theme='white' 
                            name='index'
                            value={newChapter.index}
                            handleParentChange={(name,value) => handleParentChange(name, value, true)}/> 
                        -
                    </div>
                    <Input theme='white' 
                            className='title-input'
                            name='title'
                            value={newChapter.title}
                            handleParentChange={(name,value) => handleParentChange(name, value, true)}/> 
                </div>     
            </div>
            }
            <div className="SubChapterCard new-card">
                <Icon svg={svgPlus} onClick={()=>addNewChapter()}/>
            </div>         
        </React.Fragment>
    );
}